import {
  Box,
  MenuItem,
  Select,
  Typography
} from '@mui/material'
import { color } from 'config/color'
import type React from 'react'
import { useId } from 'react'

interface YearDropDownProps {
  value: string
  onChange: any
  yearOptions: string[]
}

export const YearDropDown: React.FC<YearDropDownProps> = (
  props: YearDropDownProps
) => {
  const labelId = useId()
  const selectId = useId()

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box
        id={labelId}
        component="span"
        sx={{ color: color.grey[700], fontSize: 14, fontWeight: 400 }}
      >
        Select the year to preview:
      </Box>

      <Select
        labelId={labelId}
        id={selectId}
        value={props.value}
        onChange={props.onChange}
        displayEmpty
        renderValue={(selected) =>
          selected !== '' && selected != null
            ? <Typography>{selected}</Typography>
            : (
              <Typography sx={{ color: '#737373' }}>
                Year
              </Typography>
            )
        }
      >
        {props.yearOptions.map((year: string, index: number) => (
          <MenuItem key={index} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
